const firebaseConfig = {
    apiKey: "AIzaSyBsPGoQM6TzodMvtHZzl4A76y15rPalcwA",
    authDomain: "ema-jhon-simple12.firebaseapp.com",
    databaseURL: "https://ema-jhon-simple12.firebaseio.com",
    projectId: "ema-jhon-simple12",
    storageBucket: "ema-jhon-simple12.appspot.com",
    messagingSenderId: "223716117265",
    appId: "1:223716117265:web:26f6c8ad56efdbe57f9ab0"
  };
  export default firebaseConfig;